import { GuidService } from 'ui-components/services/guid-service';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { BulkActions } from '../../../enums/bulk-actions';

export const ShipByDate = {
  id: 'ship-by-date',
  name: BulkActions.shipByDate.message,

  makeHandler: (dispatch, bulkUpdateTypeData) => {
    return (ids, filters) =>
      dispatch(BulkUpdateActions.startBulkUpdateJob(bulkUpdateTypeData, [BulkActions.shipByDate], ids, GuidService.newGuid(), filters));
  },
};
